<template>
  <ancestryline-modal title="forms.client.title" id="modal-client-form" :close="true" @close="close" :loading="false">
    <form @submit.prevent="applyFilter">
      <card :header="$t('forms.client.card-personal-information')" class="p-col-12" >
        <coff-input-text v-model="filters.name" label="forms.client.name" class="p-col-12 p-md-6 p-lg-4" />
      </card>

    </form>

    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.clear')" @click.prevent="clearFilter" class="p-button-secondary p-mr-auto"/>
        <Button :label="$t('btn.filter')" @click.prevent="applyFilter" class="float-right p-button-primary"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalClientFilter",

  props: {
    filters: {},
  },

  methods:{

    close(){
      DialogService.closeModal();
    },

    clearFilter(){
      this.filters = {name: null};
    },

    applyFilter(){
      DialogService.closeModal(this.filters);
    },

  },

}
</script>

<style scoped>

</style>